import React from "react";
import { useNavigate } from "react-router-dom";
import "./notFound.css";
import { Helmet } from "react-helmet";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found-container">
      <Helmet>
        <title>404 - Page Not Found | Vasmi Group</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="not-found-content">
        <h1 className="error-code">404</h1>
        <div className="error-divider"></div>
        <h2 className="error-message">Oops! Page Not Found</h2>
        <p className="error-description">
          The page you are looking for might have been removed, had its name changed,
          or is temporarily unavailable.
        </p>
        <button className="back-home-btn" onClick={() => navigate("/")}>
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default NotFound;
